import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./SavedAddress.css";
import {BASE_URL} from "./Constants";


const SavedAddress = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [edit, setEdit] = useState(null);
  const [editForm, setEditForm] = useState({
    first_name: "",
    last_name: "",
    street: "",
    city: "",
    state: "",
    pin: "",
    country: "",
    phone_no: "",
    address_type: ""
  });

  // Fetch logged-in user from backend
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${BASE_URL}/get_user_details`, {
          method: "GET",
          credentials: "include", // HTTP-only cookie
        });
        if (!res.ok) throw new Error("Not logged in");
        const userData = await res.json();
        setUser(userData); // expected: { user_id, email, ... }
      } catch (err) {
        console.log("No user logged in:", err.message);
        setUser(null);
        // navigate("/checkout/login");
      }
    };
    fetchUser();
  }, [navigate]);

  // Fetch saved addresses for logged-in user
  useEffect(() => {
    if (!user) return;

    const fetchAddresses = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/fetch_address?user_id=${user.user_id}`,{
             method: "GET", 
             credentials: "include" ,
             headers: {
            "Content-Type": "application/json"
          }
          }
        );
        const data = await res.json();
        // setAddresses(Array.isArray(data) ? data : data?.data || []);
        setAddresses(data?.addresses || []);
      } catch (err) {
        console.error("Error fetching addresses:", err);
      }
    };

    fetchAddresses();
  }, [user]);

  const handleEdit = (index) => {
    setEdit(index);
    setEditForm(addresses[index]);
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`${BASE_URL}/delete_address/${id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to delete address");

      setAddresses(addresses.filter((addr) => addr.id !== id));
      if (edit !== null && addresses[edit].id === id) setEdit(null);
    } catch (err) {
      console.error(err);
      alert("Error deleting address");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/update_address/${editForm.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(editForm),
        }
      );
      if (!res.ok) throw new Error("Failed to update address");

      const data = await res.json();
      const updated = addresses.map((addr) =>
        addr.id === editForm.id ? data.data : addr
      );
      setAddresses(updated);
      setEdit(null);
      alert("Address updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Error updating address");
    }
  };

  return (
    <div className="saved-address-container">
      <h2>Saved Addresses</h2>
      {addresses.length === 0 ? (
        <p className="no-address">No saved addresses found</p>
      ) : (
        <table className="address-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Details</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {addresses.map((addr, index) => (
              <tr key={addr.id}>
                <td>{addr.address_type}</td>
                <td>
                  {addr.first_name} {addr.last_name} <br />
                  {addr.street} <br />
                  {addr.city}, {addr.state} - {addr.pin} <br />
                  {addr.country}, {addr.phone_no}
                </td>
                <td>
                  <button className="edit-btn" onClick={() => handleEdit(index)}>
                    Edit
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(addr.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {edit !== null && (
        <div className="edit-form">
          <h3>Edit Address</h3>
          {["first_name", "last_name", "street", "city", "state", "pin", "country", "phone_no", "address_type"].map(
            (field) => (
              <input
                key={field}
                type="text"
                name={field}
                placeholder={field}
                value={editForm[field] || ""}
                onChange={handleChange}
              />
            )
          )}
          <button onClick={handleSave} className="save-btn">
            Save changes
          </button>
          <button onClick={() => setEdit(null)} className="cancle-btn">
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default SavedAddress;

